import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import PageHero from '../../components/feature/PageHero';
import Diferenciais from '../home/components/Diferenciais';

const WHATSAPP_URL = 'https://wa.me/5511989036294?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

export default function DiferencialPage() {
  return (
    <main className="font-sans">
      <Header />
      <PageHero
        tag="Diferencial"
        titulo="Por que nos"
        tituloItalico="escolher"
        subtitulo="Conheça os pilares que definem nossa forma de atuar e o compromisso que assumimos com cada cliente."
      />

      <Diferenciais />

      {/* Info Cards */}
      <section className="py-[60px] bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Urgência */}
            <div className="bg-[#0A1829] rounded-lg p-8 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#B39B62]/15 border border-[#B39B62]/30 mx-auto mb-4">
                <i className="ri-alarm-warning-line text-[#B39B62] text-xl"></i>
              </div>
              <h3 className="font-serif text-xl text-white font-medium mb-2">Situações urgentes</h3>
              <p className="font-sans text-white/50 text-sm leading-relaxed mb-5">
                Flagrante, prisão, audiência de custódia ou qualquer situação crítica: resposta imediata quando o tempo é fator decisivo.
              </p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-xs px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                Atendimento imediato
              </a>
            </div>

            {/* Discrição */}
            <div className="bg-[#F8F5EE] rounded-lg border border-[#E9D59C]/50 p-8 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#B39B62]/10 border border-[#B39B62]/25 mx-auto mb-4">
                <i className="ri-lock-line text-[#B39B62] text-xl"></i>
              </div>
              <h3 className="font-serif text-xl text-[#0A1829] font-medium mb-2">Sigilo garantido</h3>
              <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed">
                Confidencialidade absoluta em todas as etapas. Seus dados e informações protegidos pelo sigilo profissional, sem exceções.
              </p>
            </div>

            {/* Atendimento direto */}
            <div className="bg-[#F8F5EE] rounded-lg border border-[#E9D59C]/50 p-8 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#B39B62]/10 border border-[#B39B62]/25 mx-auto mb-4">
                <i className="ri-user-line text-[#B39B62] text-xl"></i>
              </div>
              <h3 className="font-serif text-xl text-[#0A1829] font-medium mb-2">Advogado direto</h3>
              <p className="font-sans text-[#0A1829]/60 text-sm leading-relaxed">
                Você fala diretamente com o advogado responsável pelo seu caso. Sem intermediários, com transparência e agilidade total.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}